import Box from '@mui/material/Box';
import { useEffect } from 'react';
import { MobileCenteredLayout } from '@/components/MobileCenteredLayout/MobileCenteredLayout';
import { WelcomeFooter } from '@/components/WelcomeFooter/WelcomeFooter';
import { trackSuccessEvent } from '@/helpers/analytics';
import { SuccessCompanionsCta } from '@/Pages/Success/components/SuccessCompanionsCta';
import { SuccessHeader } from '@/Pages/Success/components/SuccessHeader';
import { SuccessIcon } from '@/Pages/Success/components/SuccessIcon';
import { SuccessRouteGuard } from '@/Pages/Success/components/SuccessRouteGuard';
import { SuccessSummaryCard } from '@/Pages/Success/components/SuccessSummaryCard';
import { useConfettiEffect } from '@/Pages/Success/hooks/useConfettiEffect';
import { useUserProfile } from '@/Pages/Success/hooks/useUserProfile';
import '@/Pages/Success/SuccessPage.sass';

function SuccessPageContent(): JSX.Element {
  const profileState = useUserProfile();

  useConfettiEffect();

  useEffect(() => {
    void trackSuccessEvent({ name: 'success_page_view' });
  }, []);

  return (
    <MobileCenteredLayout>
      <Box component="main" className="success-page" data-testid="success-page">
        <Box className="success-page__content">
          <SuccessIcon />
          <SuccessHeader />
        </Box>
        <SuccessCompanionsCta />
        <Box className="success-page__summary">
          <SuccessSummaryCard state={profileState} />
        </Box>
        <WelcomeFooter />
      </Box>
    </MobileCenteredLayout>
  );
}

export function SuccessPage(): JSX.Element {
  return (
    <SuccessRouteGuard>
      <SuccessPageContent />
    </SuccessRouteGuard>
  );
}
